import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import Typography from '../../UniformComponents/Typography'
import Button from '../../UniformComponents/Button'
import HoverInfo from '../../UniformComponents/HoverInfo'
import PreviewSlide from './PreviewSlide'
import PreviewSlideTitle from './PreviewSlideTitle'

const SlidePreview = ({ store }) => {
    const {
        onSlideDragEnd, changeCurrentSlide, currentSlide, currentSection, sections,
        slideCount, handleOpenSectionTitleModal, addSection,
        slidePreviewCollapsed, toggleSlidePreviewCollapsed,
    } = store

    const handleDeleteSlide = (sectionIdx, slideIdx) => {
        changeCurrentSlide(sectionIdx, slideIdx)
        store.deleteSlide('preview')
    }

    const containerClass = slidePreviewCollapsed
        ? 'pp-slide-preview-container pp-slide-preview-container-collapsed'
        : 'pp-slide-preview-container'

    return (
        <div className={containerClass}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 20, height: '100%', paddingBottom: 120 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Typography type="h4">Deck</Typography>

                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 100, height: 24, width: 24, backgroundColor: '#F7F5FF', color: '#715AF8' }}>
                            <Typography type="tiny-b">
                                {slideCount}
                            </Typography>
                        </div>

                        <div
                            onClick={toggleSlidePreviewCollapsed}
                            style={{ width: 30, height: 30, border: '1px solid grey', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                        >
                            <i className={`far ${slidePreviewCollapsed ? 'fa-chevrons-left' : 'fa-chevrons-right'}`} />
                        </div>
                    </div>
                </div>

                <hr />

                <div className="pp-slides-section-container">
                    <DragDropContext onDragEnd={onSlideDragEnd}>
                        {sections
                            .map((section, i) => (
                                <div className="pp-slides-section-content" style={{ minHeight: slidePreviewCollapsed ? 'auto' : 150 }}>
                                    {!slidePreviewCollapsed && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '10px',
                                                backgroundColor: '#EDF1F7',
                                                borderRadius: 6,
                                                marginBottom: 10,
                                            }}
                                        >
                                            <Typography type="b">
                                                {section.title}
                                            </Typography>

                                            <i
                                                className="far fa-pen-to-square"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleOpenSectionTitleModal(i)}
                                            />
                                        </div>
                                    )}

                                    <Droppable droppableId={`slide-list-section-${i}`}>
                                        {(pr) => (
                                            <div
                                                ref={pr.innerRef}
                                                {...pr.droppableProps}
                                                className="pp-slides-preview-container"
                                            >
                                                {section.slide
                                                    .map((slide, index) => (
                                                        <Draggable
                                                            key={slide.id}
                                                            draggableId={slide.id}
                                                            index={index}
                                                            id={slide.id}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                >
                                                                    <div onClick={() => changeCurrentSlide(i, index)} className={(currentSlide === index && currentSection === i) ? 'pp-slide-preview-wrapper-active' : 'pp-slide-preview-wrapper'}>
                                                                        <Typography type="tiny-b">{index + 1}</Typography>

                                                                        <PreviewSlide
                                                                            isActive={currentSlide === index && currentSection === i}
                                                                            slide={slide}
                                                                            isCollapsed={slidePreviewCollapsed}
                                                                            onDelete={() => handleDeleteSlide(i, index)}
                                                                        />

                                                                        {!slidePreviewCollapsed && (
                                                                            <PreviewSlideTitle slide={slide} />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                            </div>
                                        )}
                                    </Droppable>

                                    {(slidePreviewCollapsed && i !== sections.length - 1) && <hr style={{ marginTop: 5 }} />}
                                </div>
                            ))}
                    </DragDropContext>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 20, position: 'absolute', bottom: 0, left: 0, right: 0, padding: '0 20px 20px 20px', background: 'white' }}>
                <hr />

                {!store.isTemplate && (
                    store.canInsertTemplate ? (
                        <Button
                            cssClass="regular secondary"
                            style={{ width: '100%', justifyContent: 'center' }}
                            label={i18n.t('templates.insertTemplate')}
                            icon="far fa-file-import"
                            onClick={store.openInsertTemplateModal}
                        />
                    ) : (
                        <HoverInfo
                            cssClass="pp-insert-template-hover"
                            desc={store.insertTemplateTooltip}
                            dir="left"
                        >
                            <div
                                className="uc-button icon-btn regular secondary"
                                style={{ width: '100%', justifyContent: 'center', opacity: 0.5, cursor: 'not-allowed' }}
                            >
                                <i className="far fa-file-import" />
                                <b>{i18n.t('templates.insertTemplate')}</b>
                            </div>
                        </HoverInfo>
                    )
                )}

                <Button
                    cssClass="regular tertiary"
                    style={{ width: '100%', justifyContent: 'center' }}
                    label="Add section"
                    icon="far fa-plus"
                    onClick={addSection}
                />
            </div>
        </div>
    )
}

export default observer(SlidePreview)
